import { render, staticRenderFns } from "./formulario-contacto.vue?vue&type=template&id=530e9056"
import script from "./formulario-contacto.vue?vue&type=script&lang=js"
export * from "./formulario-contacto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports